import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntelligenceModels } from '@models/intelligence.model';

@Component({
  selector: 'app-locations-result',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './locations-result.component.html',
  styleUrls: ['./locations-result.component.scss'],
})
export class LocationsResultComponent {
  readonly response = input<IntelligenceModels.Locations.Response | null>(null);

  readonly locations = computed(() => this.response()?.locations ?? []);
}
